import { getPasswordStrength } from "@/lib/passwordStrength";

const SCORE_STYLES = {
  bar: ["#E2E8F0", "#E53E3E", "#D69E2E", "#3182CE", "#38A169"],
  label: ["#718096", "#C53030", "#B7791F", "#2B6CB0", "#276749"],
} as const;

interface PasswordStrengthMeterProps {
  password: string;
}

export function PasswordStrengthMeter({ password }: PasswordStrengthMeterProps) {
  if (!password) return null;

  const { score, label, missing } = getPasswordStrength(password);
  const barFill = SCORE_STYLES.bar[score];
  const labelColor = SCORE_STYLES.label[score];

  return (
    <div className="space-y-1 mt-1">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map(i => (
          <div
            key={i}
            className="h-1.5 flex-1 rounded-full transition-colors duration-200"
            style={{ backgroundColor: i <= score ? barFill : "#E2E8F0" }}
          />
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        Strength:{" "}
        <span style={{ color: labelColor }}>{label}</span>
        {missing.length > 0 && ` — needs ${missing[0]}`}
      </p>
    </div>
  );
}
